module.exports = __webpack_public_path__ + "img/030-restrict.2906afe3.svg";